// extracted by mini-css-extract-plugin
export default {"Introduce":"Introduce_Introduce__gD8BE","introducebox":"Introduce_introducebox__-zxS1","productList":"Introduce_productList__WSbWC"};